import reducer from './reducer'
import type { State } from './reducer'

import * as enrolmentEntitlementsActions from './actions'
import enrolmentEntitlementsSagas from './sagas'

export {
  enrolmentEntitlementsActions,
  enrolmentEntitlementsSagas
}

export type EnrolmentEntitlementsState = State;

export default reducer
